import { useChat } from '../context/ChatContext';
import { getActiveWorkshop } from '../utils/navigationUtils';
import { getCurrentAnalysisId } from '../utils/appStateManagerAPI';
import { useTranslation } from 'react-i18next';

// ponytail: context (tab, analysis) is read at SEND time, not subscribed reactively —
// tab state lives in EbiosRMApp component state + localStorage, so this is always fresh
// and avoids plumbing tab state through the app for zero UX gain.
export function useChatbot() {
  const { messages, isStreaming, queuePosition, sendMessage, loadHistory, clearHistory } = useChat();
  const { i18n } = useTranslation();

  const analysisId = getCurrentAnalysisId();

  const send = (text) => {
    const activeTab = localStorage.getItem('ebiosrm_active_tab') || 'dashboard';
    sendMessage(text, {
      analysisId,
      workshop: getActiveWorkshop(activeTab), // 'workshop1'..'workshop5'
      tabId: activeTab,                       // matches <!-- tab: ... --> in knowledge docs
      lang: i18n.language?.startsWith('en') ? 'en' : 'fr',
    });
  };

  const load = () => loadHistory(analysisId);
  const clear = () => clearHistory(analysisId);

  return { messages, isStreaming, queuePosition, send, load, clear };
}
